import React, { useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { IAuthData } from '@/shared/interfaces/auth-data.interface';
import SolgariLogo from '@/public/images/solgari-logo.png';
import { logger } from '@/services/logger.service';
import { MAIN } from '@/configs/main.config';
import './Login.scss';

export interface LoginProps {
  onLoginHandler: (values?: IAuthData) => Promise<void>;
}

export function Login({ onLoginHandler }: LoginProps) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sipCredsStr = localStorage.getItem(MAIN.lsSipCreds);

    if (!sipCredsStr) {
      return;
    }

    const sipCreds = JSON.parse(sipCredsStr);

    onLoginHandler(sipCreds);
  }, []);

  const onFinish = (values: IAuthData) => {
    logger.log(`Login Success`);
    setLoading(true);

    const sipCreds = JSON.stringify(values);
    localStorage.setItem(MAIN.lsSipCreds, sipCreds);

    onLoginHandler(values);
    setLoading(false);
  };

  const onFinishFailed = (errorInfo: unknown) => {
    logger.error(`Login Failed: `, errorInfo);
  };

  return (
    <div className="login">
      <img src={SolgariLogo} alt="logo" />
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="SIP uri"
          name="uri"
          rules={[
            {
              required: true,
              message: 'Please input SIP uri!',
            },
          ]}
        >
          <Input placeholder="sip:000@ucp000dev.com" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="WebSocket Server"
          name="server"
          rules={[
            {
              required: true,
              message: 'Please input WebSocket server!',
            },
            {
              type: 'regexp',
              pattern: /^wss:\/\/\w+.solgari.com/,
              message: 'Please enter a valid solgari server',
            },
          ]}
        >
          <Input placeholder="wss://ucp000.solgari.com:5065" />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            loading={loading}
            className="login__submit"
            type="primary"
            htmlType="submit"
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
